import React from 'react';

const Icon89154SingleArmChaiseRight = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <path
      d="M270.7,207.95h216.75v369.66c0,7.98-6.47,14.45-14.45,14.45h-187.85c-7.98,0-14.45-6.47-14.45-14.45V207.95h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M487.45,207.95h32.67c5.07,0,9.18,4.11,9.18,9.18v250.64c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18V207.95h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="270.7"
      y="207.95"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon89154SingleArmChaiseRight;
